import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { selectAgentList, selectAgentsSelected, SelectShowCloudAgents } from 'store/Agents/selectors';
import IconButton from 'Common/Components/IconButton';
import { ConfigIcon } from '../../styled';
import ModalWarning from 'Common/Components/ModalWarning';
import { getUserAgent, unSelectAll } from 'store/Agents/actions';
import { openModal } from 'store/modals/actions';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';

const ConfigureButton = () => {
  const dispatch = useDispatch();
  const agentsSelected = useSelector(selectAgentsSelected);
  const agents = useSelector(selectAgentList);
  const showCloudAgents = useSelector(SelectShowCloudAgents);
  const id = get(agentsSelected, '[0].id', 0);
  const [showWarning, setShowWarning] = useState(false);
  const message = showCloudAgents ? 'Please select one Security Scanner' : 'Please select one Runner';
  const handleClick = () => {
    if (agents.length > 0) {
      if (agentsSelected.length === 1) {
        dispatch(unSelectAll());
        dispatch(getUserAgent(id));
        dispatch(openModal(MODAL_AGENT_DETAIL));
      } else setShowWarning(true);
    }
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <IconButton icon={ <ConfigIcon /> } title="Configure and Run" onClick={ handleClick } disabled={ !agents.length > 0 } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title="Configure and Run" description={ message } /> }
    </>
  );
};

export default ConfigureButton;
